import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Button } from '@mui/material';

interface FileUploadButtonProps {
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const FileUploadButton = ({ onClick, disabled, className }: FileUploadButtonProps) => {
  return (
    <Button
      variant='text'
      startIcon={<FileUploadIcon fontSize='small' />}
      onClick={onClick}
      disabled={disabled}
      className={className}>
      Upload
    </Button>
  );
};
